<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div v-if="!loading && records && records.length">
      <div v-for="r in records" class="card m-2 shadow-sm">
        <div class="card-body p-2">
          <div class="flex pl-2 mb-1 justify-content-between">
            <h5 class="mb-0"><strong>{{ r.title }}</strong> <span
              class="text-muted fs-11">{{ printDate(r.created_at) }}</span></h5>
            <div class="flex">
              <LoadingButton
                v-if="$can('updateDrugStatusPrices')"
                title="Отклонить"
                className="btn btn-outline-warning"
                :onClick="() => acceptTask(sTasks[r.id]?.id, 'reject')"
                :loading="btnLoading[sTasks[r.id]?.id]"
                :color="$constants.SUCCESS_COLOR"
              />
              <LoadingButton
                v-if="$can('updateDrugStatusPrices')"
                title="Подтвердить"
                className="btn btn-success"
                :onClick="() => acceptTask(sTasks[r.id]?.id, 'accept')"
                :loading="btnLoading[sTasks[r.id]?.id]"
                :color="$constants.SUCCESS_COLOR"
              />
            </div>
          </div>
          <div class="mb-2 p-2">
            <p v-if="false" class="mb-0">Новые цены выделены зеленым</p>
            <template v-if="false">
              <SingeProjectPriceChanges
                :record="getSingleTask(r.id)"
              />
              <template v-if="localTasks[r.id].length > 2">
                <v-popover
                  popoverClass="drug_changes_tasks_popover"
                  popoverInnerClass="drug_changes_tasks_popover"
                  placement="bottom"
                  trigger="hover"
                  :delay='{ show: 150, hide: 150 }'
                >
                  <span class="badge badge-info">Всего {{ localTasks[r.id].length }} изменений</span>
                  <template slot="popover">
                    <table class="table mt-1 table-sm table-hover change_table">
                      <thead>
                      <tr>
                        <th>Проект</th>
                        <th>Изменения</th>
                        <th>Фактически</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(t, i) in localTasks[r.id]" v-if="t">
                        <td>{{ $AllProjects[t.task.project_id]?.title }}</td>
                        <td>
                          <div class="flex">
                            <span :class="{'btn btn-outline-primary': true, 'active': +t.task.is_active}">A</span>
                            <span :class="{'btn btn-outline-primary': true, 'active': +t.task.order_allow}">З</span>
                            <span class="price_span">кол. <strong>{{ t.task.qty }}</strong>: <strong>{{
                                t.task.price
                              }}</strong> ({{
                                getProfitPercent(r, t.task.price)
                              }}%)</span>
                          </div>
                        </td>
                        <td>
                          <div class="flex">
                              <span
                                :class="{'btn btn-outline-primary': true, 'active': +t.actualData.is_active}">A</span>
                            <span
                              :class="{'btn btn-outline-primary': true, 'active': +t.actualData.order_allow}">З</span>
                            <span class="price_span">кол. <strong>{{ t.actualData.qty }}</strong>: <strong>{{
                                t.actualData.price
                              }}</strong> ({{ getProfitPercent(r, t.actualData.price) }}%)</span>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </template>
                </v-popover>
              </template>
            </template>
            <div v-if="false" class="comments_block">
              <div class="comments card"
                   v-if="sTasks[r.id]?.task_data?.comments && sTasks[r.id].task_data.comments.length">
                <div class="comment_message" v-for="c in sTasks[r.id]?.task_data?.comments">
                  <p>{{ c.text }}</p>
                  <p class="text-muted text-right fs-10">{{ c.name || 'Вы' }} {{ printDate(c.created_at) }}</p>
                </div>
              </div>
              <div class="mt-1 message_form">
                <form @submit.prevent="() => updateTasks(sTasks[r.id]?.id, 'comment')" class="">
                  <div class="input-group">
                    <input type="text" placeholder="Комментарий" :disabled="sendCommentLoading[sTasks[r.id]?.id]"
                           v-model="newComments[sTasks[r.id]?.id]" class="form-control br-0">
                    <div class="input-group-append">
                      <LoadingButton
                        title="Отправить"
                        type="submit"
                        :loading="sendCommentLoading[sTasks[r.id]?.id]"
                        :color="$constants.LOADING_COLOR"
                        :onClick="() => {}"
                        className="btn btn-outline-info br-0"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div>
            <DrugsList
              :ref="`drugsList_${localTasks[r.id]?.id}`"
              :getActiveDrug="(drugData) => {}"
              :drugLinks="drugLinks"
              :records="[r]"
              :drugsTasks="[]"
              :priceChanges="(localTasks[r.id] ?? []).reduce((acc, t) => {
              acc.push(t.task)
              return acc;
            }, [])"
              :drugsOrdered="ordered"
              :invoices="invoices"
              :freezeInvoices="freezeInvoices"
              :ordersStat="ordersStat"
              :soldData="soldData"
              :storeDrugData="storeDrugData"
              :profitCalculation="profitCalculation"
            />
          </div>
        </div>
      </div>
      <div class="text-right mt-1 mr-1">
        <LoadingButton
          v-if="$can('updateDrugStatusPrices')"
          title="Принять все изменения"
          className="btn btn-success"
          :onClick="() => acceptTask(-1, 'accept')"
          :loading="btnLoading[-1]"
          :color="$constants.SUCCESS_COLOR"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import moment from 'moment'
import DrugsList from "@/views/nomenclature/components/DrugsList.vue";
import SingeProjectPriceChanges from "@/views/tasks/components/SingeProjectPriceChanges.vue";

export default {
  props: ['tasks', 'drugId', 'updateTasksPull'],
  components: {
    SingeProjectPriceChanges,
    DrugsList,
    LoadingButton,
  },
  data() {
    return {
      drugLinks: {},
      drug: null,
      records: [],
      ordered: {},
      invoices: {},
      ordersStat: {},
      soldData: {},
      storeDrugData: {},
      freezeInvoices: {},
      profitCalculation: {},
      newComments: {},
      drugData: null,
      prices: null,
      loading: false,
      sendCommentLoading: {},
      btnLoading: {
        '-1': false
      },
      localTasks: null,
      sTasks: {},
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  mounted() {
    this.profitCalculation = {
      baseMargin: 100,
      calculatedRate: 95,
      countryId: null,
      delivery: 380,
      deliveryPercent: 10,
      is_favorite: true,
      ratePercent: 6,
    };
    this.setFavoriteDetails();
    this.getDrugInfo();
  },
  watch: {
    'tasks': {
      handler: function (val, oldVal) {
        // this.getDrugInfo(true);

      },
      deep: true
    },
  },
  methods: {
    setFavoriteDetails() {
      const detail = this.$UserDetails.find((d) => d.alias === 'margin_calculation_preset');
      this.details = detail && detail.details || [];
      const index = this.details.findIndex((d) => d.is_favorite);
      if (index !== -1) {
        this.profitCalculation = {...this.details[index]}
      }
    },
    getSingleTask(drugId) {
      let task = this.localTasks[drugId].filter((t) => t.task.project_id === 1);
      if (!task.length) {
        task = this.localTasks[drugId].filter((t) => t.task.project_id === this.localTasks[drugId][0].task.project_id);
      }
      const index = this.records.findIndex((r) => r.id === drugId);
      task = task.map((t) => {
        return {
          ...t,
          profitTask: this.getProfitPercent(this.records[index], t.task.price),
          profitActual: this.getProfitPercent(this.records[index], t.actualData.price)
        }
      })
      task.projectTitle = this.$AllProjects[task[0].task.project_id].title;
      return task;
    },
    async updateTasks(id, type) {
      switch (type) {
        case 'comment':
          if (!this.newComments[id]) return;
          this.sendCommentLoading[id] = true;
          this.sendCommentLoading = {...this.sendCommentLoading};
          const {data} = await api.post('/tasks/update', {
            task_id: id,
            type: 'addComment',
            comment: this.newComments[id]
          })
          if (data.success) {
            const task = Object.values(this.sTasks).find((t) => t.id === id);
            if (!this.sTasks[task.drug_id].task_data?.comments) this.sTasks[task.drug_id].task_data.comments = [];
            this.sTasks[task.drug_id].task_data.comments.push({text: this.newComments[id]});
            this.newComments[id] = null;
          } else {
            toastr['warning'](data.message || 'Ошибка');
          }
          this.sendCommentLoading[id] = false;
          break;
      }
    },
    getProfitPercent(record, price) {
      let costPrice = +(this.invoices[record.id] && this.invoices[record.id].length && this.invoices[record.id][0] && this.invoices[record.id].length && this.invoices[record.id][0].cost_price || 0) * +(this.profitCalculation && this.profitCalculation.calculatedRate || 0);
      costPrice *= +record.pack_set;
      const setPrice = +price - (+price * +(this.profitCalculation && this.profitCalculation.deliveryPercent || 0) / (100 + (this.profitCalculation && this.profitCalculation.deliveryPercent || 0))) - +(this.profitCalculation && this.profitCalculation.delivery || 0);
      return Math.round(setPrice * 100 / costPrice) - 100;
    },
    async acceptTask(taskId, action) {
      if (Object.values(this.btnLoading).find((l) => l)) return;
      this.btnLoading[taskId] = true;
      this.btnLoading = {...this.btnLoading};
      const postData = {type: action};
      if (taskId === -1) {
        postData.task_ids = Object.values(this.sTasks).map((t) => t.id);
      } else {
        postData.task_id = taskId;
      }
      const {data} = await api.post('/tasks/update', postData);
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        if (+taskId > 0, ['accept', 'reject'].includes(action)) {
          const drugId = Object.values(this.sTasks).find((t) => t.id === +taskId)?.drug_id;
          if (drugId) {
            delete this.localTasks[drugId];
            this.records = this.records.filter((r) => r.id !== drugId);
          }
        }
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading[taskId] = false;
    },
    async getDrugInfo(silent = false) {
      this.loading = !silent;

      const drugsIds = this.tasks.map((t) => t.drug_id);
      if (!drugsIds.length) {
        this.loading = false;
        return;
      }

      let {data: r_data} = await api.post('/nomenclature/synchronize', {
        page: 1,
        filter: {
          date: moment().format('DD.MM.YYYY'),
          searchData: drugsIds,
          type: 6,
          searchOptions: {}
        }
      })

      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.ordered = r_data.ordered;
        this.invoices = r_data.invoices;
        this.ordersStat = r_data.ordersStat;
        this.soldData = r_data.soldData;
        this.storeDrugData = r_data.storeDrugData;
        this.freezeInvoices = r_data.freezeInvoices;

        this.sTasks = this.tasks.reduce((acc, t) => {
          acc[t.drug_id] = t;
          return acc;
        }, {})
        this.localTasks = data.reduce((acc, d) => {
          const tasks = this.sTasks[d.id].task_data.changes.reduce((acc, t) => {
            const price = d.prices.find((p) => p.qty === +t.qty && p.site_id === t.project_id);
            if (!price) return acc;
            if (+t.price !== +price.price || +t.is_active !== +price.is_active || +t.order_allow !== +price.order_allow) {
              const actionType = {};
              if (+t.price !== +price.price) actionType.priceChange = true;
              if (+t.is_active !== +price.is_active) actionType.activityChange = true;
              if (+t.order_allow !== +price.order_allow) actionType.orderChange = true;
              acc.push({
                task_id: this.sTasks[d.id].id,
                actionType,
                task: t,
                actualData: price,
                comments: this.sTasks[d.id].task_data.comments || []
              });
            }
            return acc;
          }, [])
          if (tasks.length) acc[d.id] = tasks;
          return acc;
        }, {})
        this.records = data;
      }
      this.loading = false;
    }
  }
}

</script>

<style>
.change_table span {
  font-size: 12px;
  padding: 4px 6px !important;
  margin-right: 3px;
}

.change_table td {
  padding: 2px;
}

.change_table tr td:first-child {
  padding-left: 10px;
}

.drug_changes_tasks_popover {
  min-width: 650px;
}
</style>

<style scoped>
label {
  margin-bottom: 0;
  padding: 1px 8px !important;
  margin-right: 3px;
}

.comments_block {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.comment_message {
  background-color: white;
  margin: 3px 5px;
  padding: 3px;
}

.comment_message p {
  margin-bottom: 0;
}

.comment_message .text-muted {
  font-size: 10px;
}

.comments {
  height: 80px;
//height: 100%; overflow: auto; background-color: #f7f7f7;
}

.action_btns_block {
  flex-direction: column;
  justify-content: end;
}

.flex_gap {
  gap: 10px;
}

.custom_btn_height {
  height: 38px;
}

.action_btns {
  align-self: start;
}
</style>
